import React from "react";
import { MapPinOff } from "lucide-react";
import { allowedArea, getDistance } from "../constants/allowedArea.js";
import MessengerPage from "../../(All) messenger/MessengerPage.jsx";

const LocationGuard = ({ userLocation, locationError, loading, t }) => {
  // Loading state
  if (loading) {
    return <div>⌛ {t.loadingLocation || "Loading location..."}</div>;
  }
  // If no location yet
  if (!userLocation && !locationError) {
    return <div>📍 {t.allowLocationAccess}</div>;
  }

  if (locationError) {
    return (
      <div style={{ color: "red", padding: "20px" }}>{locationError}</div>
    );
  }

  // Calculate distance
  const distance = getDistance(
    userLocation.lat,
    userLocation.lng,
    allowedArea.lat,
    allowedArea.lng
  );

  if (distance > allowedArea.radius) {
    return (
      <div className="fixed inset-0 flex items-center justify-center z-50">
        <div className="absolute inset-0 bg-black/20 backdrop-blur-sm" />

        <div className="relative bg-white/80 dark:bg-slate-900/80 backdrop-blur-lg rounded-3xl shadow-2xl p-8 flex flex-col items-center max-w-xs text-center border border-red-400/20">
          <div className="w-24 h-24 flex items-center justify-center mb-5 relative">
            <MapPinOff
              size={60}
              className="text-red-500/20 dark:text-red-400/20"
            />
            <div className="absolute inset-0 rounded-full bg-red-500/10 blur-xl animate-pulse" />
          </div>

          <h2 className="text-2xl font-extrabold text-red-600 dark:text-red-400 mb-2">
            {t.accessRestricted}
          </h2>

          <p className="text-gray-700 dark:text-gray-300 mb-4">
            {t.outsideOfficeArea}
          </p>

          <div className="w-full bg-red-50/30 dark:bg-slate-800/30 rounded-xl p-4 mb-4 shadow-inner">
            <p className="text-sm text-gray-600 dark:text-gray-400 mb-1">
              {t.distanceFromOffice}
            </p>
            <p className="text-xl font-bold text-gray-900 dark:text-gray-100">
              {Math.round(distance).toLocaleString()}{" "}
              <span className="text-sm font-medium">{t.meters}</span>
            </p>
          </div>

          <p className="text-sm text-gray-600 dark:text-gray-400">
            {t.moveCloserToOffice}{" "}
            <strong className="font-semibold text-gray-900 dark:text-gray-100">
              {t.messages}
            </strong>.
          </p>
        </div>
      </div>
    );
  }

  // ✅ Allowed → show messages page
  return <MessengerPage />;
};

export default LocationGuard;